import { NgModule } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from './pipes/pipes.module';
import { HttpClientModule } from '@angular/common/http';
import { SpinnerOverlayComponent } from './spinner-overlay/spinner-overlay.component';
import { MaterialUiModule } from '@deltager/organizers/admin/core/material-ui/material-ui.module';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DateInputComponent } from '@deltager/organizers/admin/shared/components/date-input/date-input.component';
import { DropdownInputComponent } from '@deltager/organizers/admin/shared/components/drop-down-input/drop-down-input.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MbscDatepickerModule, MbscModule } from '@mobiscroll/angular';
import { DateRangeInputComponent } from '@deltager/organizers/admin/shared/components/date-range-input/date-range-input.component';
import { DaySessionTimeInputComponent } from '@deltager/organizers/admin/shared/components/day-session-time-input/day-session-time-input.component';
import { IconPickerComponent } from './components/icon-picker/icon-picker.component';
import { IconPickerModule } from 'ngx-icon-picker';
import { LocationComponent } from './components/location/location.component';
import { DirectivesModule } from './directives.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BookingEventHeaderComponent } from './components/booking-event-header/booking-event-header.component';
import { SearchableDropdownComponent } from './components/searchable-dropdown/searchable-dropdown.component';
import { EditableContentComponent } from './components/editable-content/editable-content.component';
import { BaseDialogComponent } from '@deltager/organizers/admin/shared/components/base-dialog/base-dialog.component';
import { BackToListComponent } from './components/back-to-list/back-to-list.component';
import { DisplayErrorPipe } from './pipes/display-error.pipe';

@NgModule({
  declarations: [
    SpinnerOverlayComponent,
    ConfirmDialogComponent,
    DateInputComponent,
    DateRangeInputComponent,
    DropdownInputComponent,
    DaySessionTimeInputComponent,
    IconPickerComponent,
    LocationComponent,
    BookingEventHeaderComponent,
    EditableContentComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MbscModule,
    MaterialUiModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MbscDatepickerModule,
    NgxMaskDirective,
    NgxMaskPipe,
    IconPickerModule,
    DirectivesModule,
    ClipboardModule,
    NgxMatSelectSearchModule,
    SearchableDropdownComponent,
    BaseDialogComponent,
    BackToListComponent,
    DisplayErrorPipe,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    HttpClientModule,
    MaterialUiModule,
    ReactiveFormsModule,
    PipesModule,
    DateInputComponent,
    SpinnerOverlayComponent,
    ConfirmDialogComponent,
    DaySessionTimeInputComponent,
    DateRangeInputComponent,
    DropdownInputComponent,
    IconPickerComponent,
    LocationComponent,
    ClipboardModule,
    BookingEventHeaderComponent,
    EditableContentComponent,
    BackToListComponent,
  ],
  providers: [CurrencyPipe, { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, provideNgxMask()],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      imports: [],
      exports: [],
    };
  }
}
